class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    if (this.notification) {
      this.notification.addEventListener(
        'keyup',
        (evt) => evt.code === 'Escape' && this.close()
      );
    }

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener(
        'click',
        this.close.bind(this)
      )
    );
  }

  open() {
    if (!this.notification) return;

    this.notification.classList.add(
      'animate',
      'active'
    );

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener(
      'click',
      this.onBodyClick
    );

    this.dispatchCartViewEvent();

    updateRebolfBagCount();
  }

  async dispatchCartViewEvent() {
    const { CartViewEvent } =
      window.StandardEvents || {};

    if (!CartViewEvent) return;

    try {
      const response = await fetch(
        `${routes.cart_url}.json`
      );

      const cart = await response.json();

      if (!cart?.currency) return;

      this.dispatchEvent(
        new CartViewEvent({
          context: 'dialog',
          cart:
            CartViewEvent.createCartFromAjaxResponse(
              cart
            ),
        })
      );
    } catch (e) {
      // Informational event only.
    }
  }

  close() {
    if (!this.notification) return;

    this.notification.classList.remove(
      'active'
    );

    document.body.removeEventListener(
      'click',
      this.onBodyClick
    );

    removeTrapFocus(
      this.activeElement
    );

    /*
     * Re-check the cart after closing.
     * This catches the empty-cart state.
     */
    setTimeout(
      updateRebolfBagCount,
      100
    );
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach(
      (section) => {
        const element =
          document.getElementById(
            section.id
          );

        if (!element) return;

        element.innerHTML =
          this.getSectionInnerHTML(
            parsedState.sections[
              section.id
            ],
            section.selector
          );
      }
    );

    if (this.header) {
      this.header.reveal();
    }

    /*
     * Shopify has finished adding the item.
     */
    this.open();

    /*
     * Update BAG immediately.
     */
    setTimeout(
      updateRebolfBagCount,
      100
    );
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector:
          `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    const parsedHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const element =
      parsedHTML.querySelector(selector);

    return element
      ? element.innerHTML
      : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (
      target !== this.notification &&
      !target.closest(
        'cart-notification'
      )
    ) {
      const disclosure =
        target.closest(
          'details-disclosure, header-menu'
        );

      this.activeElement =
        disclosure
          ? disclosure.querySelector(
              'summary'
            )
          : null;

      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define(
  'cart-notification',
  CartNotification
);


/* =========================================================
   REBOLF — SINGLE BAG COUNT FUNCTION
   ========================================================= */

async function updateRebolfBagCount() {
  try {
    const response = await fetch(
      `${routes.cart_url}.js`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) return;

    const cart =
      await response.json();

    const count =
      Number(cart.item_count) || 0;

    /*
     * Shopify can completely replace
     * the cart icon after an AJAX update,
     * so always find it again.
     */
    const cartLinks =
      document.querySelectorAll(
        '#cart-icon-bubble'
      );

    cartLinks.forEach(
      (cartLink) => {

        /*
         * Desktop BAG count
         */
        const countBubble =
          cartLink.querySelector(
            '.cart-count-bubble'
          );

        if (countBubble) {

          countBubble.style.display =
            'inline-flex';

          countBubble.style.visibility =
            'visible';

          countBubble.style.opacity =
            '1';

          const visibleCount =
            countBubble.querySelector(
              '[aria-hidden="true"]'
            );

          if (visibleCount) {
            visibleCount.textContent =
              count;
          }

          const hiddenCount =
            countBubble.querySelector(
              '.visually-hidden'
            );

          if (hiddenCount) {
            hiddenCount.textContent =
              `${count} ${
                count === 1
                  ? 'item'
                  : 'items'
              }`;
          }
        }

        /*
         * Your custom BAG text.
         *
         * If your desktop header uses
         * .header-cart-count, keep it
         * synchronized as well.
         */
        const customCount =
          cartLink.querySelector(
            '.header-cart-count'
          );

        if (customCount) {
          customCount.textContent =
            `(${count})`;
        }
      }
    );

    /*
     * Also update any custom BAG count
     * outside #cart-icon-bubble.
     */
    document
      .querySelectorAll(
        '.header-cart-count'
      )
      .forEach(
        (element) => {
          element.textContent =
            `(${count})`;
        }
      );

  } catch (error) {
    console.warn(
      'REBOLF: Could not update BAG count.',
      error
    );
  }
}


/* =========================================================
   REBOLF — CART CHANGE EVENTS
   ========================================================= */

document.addEventListener(
  'cart:updated',
  function () {
    setTimeout(
      updateRebolfBagCount,
      100
    );
  }
);

document.addEventListener(
  'cart:update',
  function () {
    setTimeout(
      updateRebolfBagCount,
      100
    );
  }
);

document.addEventListener(
  'cart:refresh',
  function () {
    setTimeout(
      updateRebolfBagCount,
      100
    );
  }
);


/* =========================================================
   REBOLF — CART DRAWER CHANGES
   ========================================================= */

document.addEventListener(
  'change',
  function (event) {

    if (
      event.target.closest(
        'cart-drawer'
      ) ||
      event.target.closest(
        '.cart-item'
      )
    ) {

      setTimeout(
        updateRebolfBagCount,
        200
      );
    }
  }
);


/* =========================================================
   REBOLF — REMOVE ITEM
   ========================================================= */

document.addEventListener(
  'click',
  function (event) {

    const removeButton =
      event.target.closest(
        'cart-remove-button, .cart-item__remove, [data-cart-remove]'
      );

    if (!removeButton) return;

    /*
     * Shopify needs a moment to finish
     * the AJAX cart update.
     */
    setTimeout(
      updateRebolfBagCount,
      300
    );

    /*
     * Extra check for the final item
     * being removed.
     */
    setTimeout(
      updateRebolfBagCount,
      700
    );
  }
);


/* =========================================================
   REBOLF — INITIAL LOAD
   ========================================================= */

if (
  document.readyState ===
  'loading'
) {

  document.addEventListener(
    'DOMContentLoaded',
    function () {
      updateRebolfBagCount();
    }
  );

} else {

  updateRebolfBagCount();

}